import { img } from '../conf'
export const toolsRender = (colorItemList, sizeItemList) => {
  return {
    color: (h) => {
      return (
        <div class='tool-btn'>
          <div class="color-box group-box">
            <button type="button" class="our-btn group-btn"
                action="color"
                action-name="字体颜色"
                value="#333333">
              <div class="color-icon">A</div>
              <div class="color-icon-line"></div>
            </button>
            <div class="select-warp color">
              <button type="button" class="our-btn radio">
                <span class="tool-icon tool-icon-xiala" domPropsInnerHTML={img.dropDownImg}></span>
              </button>
              <div class="our-sel-warp sel-hidden">
                <div class="our-sel" domPropsInnerHTML={colorItemList}>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-desc" style="margin-left: -8px">颜色 </div>
        </div>
      )
    },
    size: (h) => {
      return (
        <div class='tool-btn'>
          <div class="select-warp size">
            <button type="button"
                    class="our-btn size-btn"
                    action="size"
                    action-name="字体大小">
              <span class="font-size">12</span>
              <span class="tool-icon tool-icon-xiala" domPropsInnerHTML={img.dropDownImg}></span>
            </button>
            <div class="our-sel-warp sel-hidden">
              <div class="our-sel column" domPropsInnerHTML={sizeItemList}>
              </div>
            </div>
          </div>
          <div class="btn-desc" style="margin-left: -4px">字号</div>
        </div>
      )
    },
    background: (h) => {
      return (
        <div class='tool-btn'>
          <div class="font-bg-box group-box">
            <button type="button" class="our-btn font-bg-btn"
                action="background"
                action-name="背景色"
                value="#333333">
              <span class="tool-icon font-bg-img" domPropsInnerHTML={img.background}></span>
              <div class="group-icon-line"></div>
            </button>
            <div class="select-warp color background-color">
              <button type="button" class="our-btn radio">
                <span class="tool-icon tool-icon-xiala" domPropsInnerHTML={img.dropDownImg}></span>
              </button>
              <div class="our-sel-warp sel-hidden">
                <div class="our-sel" domPropsInnerHTML={colorItemList}>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-desc" style="margin-left: -6px">背景色</div>
        </div>
      )
    },
    bold: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
              class="our-btn bold-btn"
              action="bold"
              action-name="加粗">
            <span class="tool-icon" domPropsInnerHTML={img.blodImg}></span>
          </button>
          <div class="btn-desc">加粗</div>
        </div>
      )
    },
    italic: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn italic-btn"
                action="italic"
                action-name="斜体">
            <span class="tool-icon" domPropsInnerHTML={img.italicImg}></span>
          </button>
          <div class="btn-desc">斜体</div>
        </div>
      )
    },
    underline: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn underline-btn"
                action="underline"
                action-name="下划线">
            <span class="tool-icon" domPropsInnerHTML={img.underlineImg}></span>
          </button>
          <div class="btn-desc">下划线</div>
        </div>
      )
    },
    deleteline: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn deleteline-btn"
                action="deleteline"
                action-name="删除线">
            <span class="tool-icon" domPropsInnerHTML={img.deleteline}></span>
          </button>
          <div class="btn-desc">删除线</div>
        </div>
      )
    },
    align: (h) => {
      return (
        <div class='tool-btn'>
          <div class="select-warp align">
            <button type="button"
                    class="our-btn align-btn"
                    action="align"
                    action-name="对齐方式">
              <span class="tool-icon tool-icon-value" domPropsInnerHTML={img.alignLeftImg}></span>
              <span class="tool-icon tool-icon-xiala" domPropsInnerHTML={img.dropDownImg}></span>
            </button>
            <div class="our-sel-warp sel-hidden">
              <div class="our-sel column">
                <div class="our-sel-item">
                  <button type="button"
                          class="alignLeft"
                          action="alignLeft">
                    <span class="tool-icon" domPropsInnerHTML={img.alignLeftImg}></span>
                  </button>
                </div>
                <div class="our-sel-item">
                  <button type="button"
                          class="alignCenter"
                          action="alignCenter"
                          value="center">
                    <span class="tool-icon" domPropsInnerHTML={img.alignCenterImg}></span>
                  </button>
                </div>
                <div class="our-sel-item">
                  <button type="button"
                          class="alignRight"
                          action="alignRight"
                          value="right">
                    <span class="tool-icon" domPropsInnerHTML={img.alignRightImg}></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-desc" style="margin-left: -4px">对齐</div>
        </div>
      )
    },
    image: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn image-btn"
                action="image"
                action-name="图片">
            <span class="tool-icon" domPropsInnerHTML={img.imageImg}></span>
          </button>
          <div class="btn-desc">图片</div>
        </div>
      )
    },
    ordered: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn ordered-btn"
                action="ordered"
                action-name="有序列表">
            <span class="tool-icon" domPropsInnerHTML={img.orderedImg}></span>
          </button>
          <div class="btn-desc">有序</div>
        </div>
      )
    },
    bullet: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn bullet-btn"
                action="bullet"
                action-name="无序列表">
            <span class="tool-icon" domPropsInnerHTML={img.bulletImg}></span>
          </button>
          <div class="btn-desc">无序</div>
        </div>
      )
    },
    indent1: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn indent1-btn"
                action="indent1"
                action-name="缩进">
            <span class="tool-icon" domPropsInnerHTML={img.indentImg}></span>
          </button>
          <div class="btn-desc">缩进</div>
        </div>
      )
    },
    indent2: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn indent2-btn disabled"
                action="indent2"
                action-name="取消缩进">
            <span class="tool-icon" domPropsInnerHTML={img.removeIndentImg}></span>
          </button>
          <div class="btn-desc">伸出</div>
        </div>
      )
    },
    undo: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn undo-btn disabled"
                action="undo"
                action-name="撤销">
            <span class="tool-icon" domPropsInnerHTML={img.undoImg}></span>
          </button>
          <div class="btn-desc">撤销</div>
        </div>
      )
    },
    redo: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
                class="our-btn redo-btn disabled"
                action="redo"
                action-name="恢复">
            <span class="tool-icon" domPropsInnerHTML={img.redoImg}></span>
          </button>
          <div class="btn-desc">恢复</div>
        </div>
      )
    },
    split: (h) => {
      return (
        <div class="split-line"></div>
      )
    },
    selectUser: (h) => {
      return (
          <div class='tool-btn'>
          <button type="button"
              class="our-btn selectUser-btn"
              action="selectUser"
              action-name="选择用户">
          <span class="tool-icon" domPropsInnerHTML={img.selectUserImg}></span>
        </button>
        <div class="btn-desc">用户</div>
      </div>
      )
    },
    uploadFile: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
              class="our-btn uploadFile-btn"
              action="uploadFile"
              action-name="上传文件">
          <span class="tool-icon" domPropsInnerHTML={img.uploadFile}></span>
        </button>
        <div class="btn-desc">附件</div>
      </div>
      )
    },
    painter: (h) => {
      return (
        <div class='tool-btn'>
          <button type="button"
              class="our-btn painter-btn"
              action="painter"
              action-name="格式刷">
          <span class="tool-icon" domPropsInnerHTML={img.painter}></span>
        </button>
        <div class="btn-desc">格式刷</div>
       </div>
      )
    },
    link: (h) => {
      return (
        <div class='tool-btn'>
        <button type="button"
            class="our-btn link-btn"
            action="link"
            action-name="添加链接">
        <span class="tool-icon" domPropsInnerHTML={img.link}></span>
      </button>
        <div class="btn-desc">链接</div>
      </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-editor-new/components/tools.js